var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusCircleIncomplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 4,
    fill: "#F0F1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9375 16.75C25.9375 13.5703 24.2188 10.6484 21.4688 9.01562C18.6758 7.42578 15.2812 7.42578 12.5312 9.01562C9.73828 10.6484 8.0625 13.5703 8.0625 16.75C8.0625 19.9727 9.73828 22.8945 12.5312 24.5273C15.2813 26.1172 18.6758 26.1172 21.4688 24.5273C24.2188 22.8945 25.9375 19.9727 25.9375 16.75ZM6 16.75C6 12.8398 8.0625 9.23047 11.5 7.25391C14.8945 5.27734 19.0625 5.27734 22.5 7.25391C25.8945 9.23047 28 12.8398 28 16.75C28 20.7031 25.8945 24.3125 22.5 26.2891C19.0625 28.2656 14.8945 28.2656 11.5 26.2891C8.0625 24.3125 6 20.7031 6 16.75Z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusCircleIncomplete);
export default __webpack_public_path__ + "static/media/status-circle-incomplete.d345fe0b5875c85add3fdc349a736ab5.svg";
export { ForwardRef as ReactComponent };